import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Cookies from 'js-cookie';
import { COOKIE_KEYS } from '../config/cookieConstants';
import { AppRoutes } from './AppRoutes';

const PrivateRoute: React.FC = () => {
  const token = Cookies.get(COOKIE_KEYS.TOKEN);
  const company = Cookies.get(COOKIE_KEYS.COMPANY_UUID);

  if (!token) {
    return <Navigate to={AppRoutes.LOGIN} replace />;
  }

  if (!company) {
    return <Navigate to={AppRoutes.SELECT_COMPANY} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
